"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastTypeEnum = exports.ToastPositionEnum = void 0;
let ToastTypeEnum = exports.ToastTypeEnum = /*#__PURE__*/function (ToastTypeEnum) {
  ToastTypeEnum[ToastTypeEnum["info"] = 0] = "info";
  ToastTypeEnum[ToastTypeEnum["success"] = 1] = "success";
  ToastTypeEnum[ToastTypeEnum["error"] = 2] = "error";
  ToastTypeEnum[ToastTypeEnum["warning"] = 3] = "warning";
  return ToastTypeEnum;
}({});
let ToastPositionEnum = exports.ToastPositionEnum = /*#__PURE__*/function (ToastPositionEnum) {
  ToastPositionEnum[ToastPositionEnum["topLeft"] = 0] = "topLeft";
  ToastPositionEnum[ToastPositionEnum["topCenter"] = 1] = "topCenter";
  ToastPositionEnum[ToastPositionEnum["topRight"] = 2] = "topRight";
  ToastPositionEnum[ToastPositionEnum["bottomLeft"] = 3] = "bottomLeft";
  ToastPositionEnum[ToastPositionEnum["bottomCenter"] = 4] = "bottomCenter";
  ToastPositionEnum[ToastPositionEnum["bottomRight"] = 5] = "bottomRight";
  return ToastPositionEnum;
}({});